import O1HD from "../../engines/gameEngine";
import getOneSpendEventById from "./config/SpendEventConfig";
import { NpcEventRel } from "./config/SpendInterface";
import { getOneNpcAgreenChats, getOneNpcNotAgreenChats, getOneNpcRefuseChats } from "./config/SpendNpcConfig";
import spendMode from "./spendMode";

const {ccclass, property} = cc._decorator;

@ccclass
export default class NpcObj extends cc.Component {
    @property({type:cc.Node,displayName:"房子图片"})
    hoouseSp:cc.Node = null;
    @property({type:cc.SpriteFrame,displayName:"房子升级图片"})
    houseUpSp:cc.SpriteFrame = null;
    @property({type:cc.SpriteFrame,displayName:"普通房子图片"})
    houseNormalSp:cc.SpriteFrame = null;

    infoNode:cc.Node = null;

    @property(spendMode)
    gameLayer:spendMode = null;

    @property({type:cc.Node,displayName:"infoLayout"})
    infoLayout:cc.Node = null;

    npcName:string[] = [];

    @property({type:cc.String,displayName:"npc的名字"})
    hasName:string[] = [];

    isEvent:boolean = false;

    currentItem:NpcEventRel[] = null;

    onLoad(){
        this.node.on("touchstart",this.onClickDialog,this);
        this.infoNode = this.hoouseSp.getChildByName("infoNode");
        this.loadNpcInfo();
        this.updateDialog();
    }

    start(): void {
        this.infoLayout.active = true;
    }



    addOneNpc(oneNpc:string){
        if(!this.hasName.includes(oneNpc)){
            return;
        }
        if(this.npcName.includes(oneNpc)){
            return;
        }
        this.npcName.push(oneNpc);
        this.updateDialog();
    }

    loadNpcInfo(){
        this.infoLayout.children.forEach((n:cc.Node,index:number)=>{
            n.on("touchend",this.onClickNpcInfo,this);
            let nHeadNode:cc.Node = n.getChildByName("head");
            let nNameNode:cc.Node = n.getChildByName("lb_Name");
            let nHeadSprite:cc.Sprite = nHeadNode.getComponent(cc.Sprite);
            let nNameLabel:cc.Label = nNameNode.getComponent(cc.Label);
            let nName:string = this.hasName[index];
            if(nName){
                nNameLabel.string = nName;
                //  路径需要完善  路径完善之后就Ok了  加载一个小头像
                // O1HD.getManagers().gameMgr.getCurrMode().bundle.load(`res/Image/npc/circleIcon/${nName}`,cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>{
                //     if(err){
                //         console.error(err);
                //     }else{
                //         nHeadSprite.spriteFrame = spr;
                //     }
                // });
                
            }else{
                n.active = false;
            }
        });
    }

    onClickDialog(){
        if(!spendMode.canClick) return;
        spendMode.canClick = false;
        if(this.npcName.length <1){
            let refuseChat:string[] = getOneNpcRefuseChats(this.hasName[0]);
            this.showHouseChat(refuseChat[0]);
        }else{
            spendMode.canClick = true;
        }
        // this.infoLayout.active = !this.infoLayout.active;
    }

    async onClickNpcInfo(e:cc.Event.EventTouch){
        if(!spendMode.canClick) return;
        spendMode.canClick = false;
        console.log("点击??????")
        let node:cc.Node = e.target;
        let siblingIndex:number = node.getSiblingIndex();
        let item:NpcEventRel = this.gameLayer.manage.getGameData()._currentEvents.find((i)=>{
            return i.npc == this.hasName[siblingIndex];
        });
        if(item){
            if(item.triggerDays && item.triggerDays < this.gameLayer.manage.getGameData()._gameDays){
                //
                await this.showOneChat(node,"外出中");
                return;
            }
            let eventId:string = item.eventId;
            let event = getOneSpendEventById(eventId);
            if(item.investCoins > 0){
                // 已投资
                let agreenChats:string[] = getOneNpcAgreenChats(item.npc);
                if(agreenChats.length > 0){
                    await this.showOneChat(node,agreenChats[Math.floor(Math.random()*agreenChats.length)] || "");
                }else{
                    spendMode.canClick = true;
                }
                //如果当天没有投资行为过
                if ( item.todayInvestCoins == 0 ){
                    this.gameLayer.openOneEvent(eventId);
                    spendMode.canClick = true;
                }
                return
            }else{
                // 未投资
                let notAgreenChats:string[] = getOneNpcNotAgreenChats(item.npc);
                if(notAgreenChats.length > 0){
                    await this.showOneChat(node,notAgreenChats[Math.floor(Math.random()*notAgreenChats.length)] || "");
                }else{
                    spendMode.canClick = true;
                }

                //如果当天没有投资行为过
                if ( item.todayInvestCoins == 0 || item.todayInvestCoins == 1 ) {
                    this.gameLayer.openOneEvent(eventId);
                }
                return ;
            }
            // }
        }else{
            // 拒绝文案
            let refuseChat:string[] = getOneNpcRefuseChats(this.hasName[0]) || [""];
            this.showHouseChat(refuseChat[Math.floor(Math.random()*refuseChat.length)]) || "";
            spendMode.canClick = true;
            return
        }
    }
    /**
     * 展示一个气泡
     */
    async showOneChat(item:cc.Node,chat:string){
        return new Promise<void>(resolve=>{
            let itemChat:cc.Node = item.getChildByName("chatNode");
            let chatLbNode:cc.Node = itemChat.getChildByName("kuang").getChildByName("chatLb");
            let chatLb:cc.Label = chatLbNode.getComponent(cc.Label);
            chatLb.string = chat;
            itemChat.active = true;
            itemChat.scale = 0;
            cc.tween(itemChat).to(.5,{scale:1},{easing:cc.easing.backOut}).delay(2).to(.5,{scale:0},{easing:cc.easing.backIn}).start();
            this.scheduleOnce(()=>{
                spendMode.canClick = true;
                resolve();
            },1.5 );
        });
    }

    async showHouseChat(chat:string){
        return new Promise<void>(resolve=>{
            let houseChatNode:cc.Node = this.hoouseSp.getChildByName("chatNode");
            let houseChatLb:cc.Label = houseChatNode.getChildByName("kuang").getChildByName("chatLb").getComponent(cc.Label);
            houseChatLb.string = chat;
            houseChatNode.active = true;
            houseChatNode.scale = 0;
            cc.tween(houseChatNode).to(.5,{scale:1},{easing:cc.easing.backOut}).delay(2).to(.5,{scale:0},{easing:cc.easing.backIn}).start();
            this.scheduleOnce(()=>{
                spendMode.canClick = true;
                resolve();
            },3);
        });
    }

    updateDialog(){
        this.infoLayout.children.forEach((n:cc.Node,index:number)=>{
            let nStr:string = this.hasName[index];
            if(this.npcName.includes(nStr)){
                n.active = true;
            }else{
                n.active = false;
            }
        });
    }

    upGrade(){
        this.hoouseSp.getComponent(cc.Sprite).spriteFrame = this.houseUpSp;
    }

    normal(){
        this.hoouseSp.getComponent(cc.Sprite).spriteFrame = this.houseNormalSp;
    }

}
